import { render, staticRenderFns } from "./SidebarResumeCreation.vue?vue&type=template&id=01bb9a70&scoped=true&"
import script from "./SidebarResumeCreation.vue?vue&type=script&lang=js&"
export * from "./SidebarResumeCreation.vue?vue&type=script&lang=js&"
import style0 from "./SidebarResumeCreation.vue?vue&type=style&index=0&id=01bb9a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bb9a70",
  null
  
)

export default component.exports